export default __webpack_public_path__ + "static/media/playstoreWeb.46502e0c.svg";